import React from 'react';
import { connect } from 'react-redux';
import { BurgerMenuContainer } from '../burger-menu/burger-menu';
import { Navbar } from '../navbar/navbar';

const NotFound = React.createClass({
  renderMain() {
    return (
      <div className="not-found-container">
        <div>Sorry, we could not find what you were looking for.</div>
      </div>
    );
  },

  renderNavbar() {
    return (
      <div id="outer-container">
        <BurgerMenuContainer
          pageWrapId={'page-wrap'}
          outerContainerId="outer-container"
        />
        <Navbar {...this.props} title="Page Not Found" />
      </div>
    );
  },

  render() {
    return (
      <div>
        {this.renderNavbar()}
        {this.renderMain()}
      </div>
    );
  }
});

const mapStateToProps = state => ({
  account: state.auth.get('user'),
  isAuthenticated: state.auth.get('isAuthenticated')
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export const NotFoundContainer = connect(mapStateToProps, mapDispatchToProps)(
  NotFound
);



/** WEBPACK FOOTER **
 ** ./src/components/not-found/not-found.js
 **/